import React from "react";
import { Link, useParams } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";
import OurCompanies from "../Home/OurCompanies";
import "./IconicBlogDetails.css";
import { blogPosts } from "./blogData";

const IconicBlogDetails = () => {
  const { slug } = useParams();
  const post = blogPosts.find((item) => item.slug === slug);

  if (!post) {
    return (
      <div className="blog-details-not-found">
        <h2>Article not found</h2>
        <p>The article you are looking for is unavailable or may have been moved.</p>
        <Link to="/blogs" className="blog-details-back-link">
          Back to all blogs
        </Link>
      </div>
    );
  }

  const relatedPosts = blogPosts
    .filter((item) => item.id !== post.id && item.category === post.category)
    .slice(0, 2);

  return (
    <div className="blog-details-page">
      <section className="blog-details-hero">
        <div className="blog-details-hero-shell">
          <div className="blog-details-hero-copy">
            <Link to="/blogs" className="blog-details-back-btn">
              <FaArrowLeft />
              Back to blogs
            </Link>
            <span className="blog-details-badge">{post.categoryLabel}</span>
            <h1>{post.title}</h1>
            <p>{post.intro}</p>
            <div className="blog-details-meta">
              <span>{post.author}</span>
              <span className="blog-details-dot">&bull;</span>
              <span>{post.date}</span>
              <span className="blog-details-dot">&bull;</span>
              <span>{post.readTime}</span>
            </div>
          </div>

          <div className="blog-details-visual-card">
            <div className="blog-details-hero-overlay" />
            <img src={post.image} alt={post.title} className="blog-details-hero-image" />
            <div className="blog-details-visual-note">
              <span>{post.categoryLabel}</span>
              <strong>Iconic Unity Group Insight</strong>
            </div>
          </div>
        </div>
      </section>

      <section className="blog-details-shell">
        <div className="blog-details-main">
          <article className="blog-details-article">
            <div className="blog-details-intro-card">
              <span className="blog-details-section-kicker">Overview</span>
              <h2>Article Overview</h2>
              <p>{post.excerpt}</p>
            </div>

            <div className="blog-details-highlights">
              {post.highlights.map((item) => (
                <div key={item} className="blog-details-highlight-item">
                  <span className="blog-details-highlight-bullet" />
                  <span>{item}</span>
                </div>
              ))}
            </div>

            <div className="blog-details-sections">
              {post.sections.map((section) => (
                <section key={section.heading} className="blog-details-section">
                  <h3>{section.heading}</h3>
                  <p>{section.body}</p>
                </section>
              ))}
            </div>
          </article>

          <aside className="blog-details-sidebar">
            <div className="blog-details-side-card">
              <span className="blog-details-side-kicker">Quick takeaway</span>
              <h3>Why it matters</h3>
              <p>{post.relatedNote}</p>
            </div>

            <div className="blog-details-side-card">
              <span className="blog-details-side-kicker">Explore more</span>
              <h3>Need more insights?</h3>
              <p>
                Explore more stories from Iconic Unity Group and discover how each
                concern is creating impact.
              </p>
              <Link to="/blogs" className="blog-details-primary-link">
                Explore all articles
              </Link>
            </div>
          </aside>
        </div>
      </section>

      {relatedPosts.length > 0 && (
        <section className="blog-details-related-wrap">
          <div className="blog-details-related-header">
            <span>More in {post.categoryLabel}</span>
            <h2>Related Articles</h2>
          </div>
          <div className="blog-details-related-grid">
            {relatedPosts.map((item) => (
              <Link to={`/blogs/${item.slug}`} key={item.id} className="blog-details-related-card">
                <img src={item.image} alt={item.title} />
                <div>
                  <span>{item.categoryLabel}</span>
                  <h3>{item.title}</h3>
                  <p>{item.excerpt}</p>
                </div>
              </Link>
            ))}
          </div>
        </section>
      )}

      <div className="blog-details-company-wrap">
        <OurCompanies />
      </div>
    </div>
  );
};

export default IconicBlogDetails;
